// Copyright (c) 2023 Deere & Company
import t from 'tcomb';

const IncentivePrograms = t.struct({
    incentiveURL: t.String,
    label: t.String
}, {
    name: 'IncentivePrograms',
    strict: true
});

export const getDefaultState = () => new IncentivePrograms({
    incentiveURL: '',
    label: ''
});

export default IncentivePrograms;


// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/incentive-programs.js